import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import conferenceAndTradeMissionService from "../../api/ConferenceAndTradeMission";
import TradeMissionRegistration from "./trade_mission_registration/TradeMissionRegistration";
import ConferenceRegistration from "./conference_registration/ConferenceRegistration";
import GroupConferenceRegistration from "./conference_registration/GroupConferenceRegistration";
import RegistrationTypeChoice from "./conference_registration/RegistrationTypeChoice";

export default function EventRegistrationRouter() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [eventType, setEventType] = useState(null);
  const [eventTitle, setEventTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [registrationMode, setRegistrationMode] = useState(null); // null | 'single' | 'group' (conference only)

  useEffect(() => {
    const fetchEventType = async () => {
      if (!slug) {
        navigate("/conference-trade-mission");
        return;
      }

      setLoading(true);
      try {
        const response = await conferenceAndTradeMissionService.getEventDetails(slug);

        if (response.data?.status_code === 200 && response.data?.data?.event) {
          const event = response.data.data.event;
          const isConference = event.event_type?.includes("conference");
          setEventType(isConference ? "conference" : "trade_mission");
          setEventTitle(event.event_title || "");
        } else {
          toast.error("Failed to load event details");
          navigate(`/event-details/${slug}`);
        }
      } catch (error) {
        toast.error("An error occurred while loading event details");
        navigate(`/event-details/${slug}`);
      } finally {
        setLoading(false);
      }
    };

    fetchEventType();
  }, [slug, navigate]);

  useEffect(() => {
    if (location.state?.resetRegistrationMode && eventType === "conference") {
      setRegistrationMode(null);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.resetRegistrationMode, location.pathname, navigate, eventType]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="relative">
          <div className="w-16 h-16 rounded-full border-4 border-orange-200 animate-spin border-t-orange-500" />
        </div>
      </div>
    );
  }

  if (eventType === "conference") {
    const backToTypeSelection = () =>
      navigate(`/event-details/${slug}/register`, { state: { resetRegistrationMode: true } });
    if (registrationMode === "single") {
      return <ConferenceRegistration onBackToTypeSelection={backToTypeSelection} />;
    }
    if (registrationMode === "group") {
      return <GroupConferenceRegistration onBackToTypeSelection={backToTypeSelection} />;
    }
    return (
      <RegistrationTypeChoice
        eventTitle={eventTitle}
        onSelectSingle={() => setRegistrationMode("single")}
        onSelectGroup={() => setRegistrationMode("group")}
        onBack={() => navigate(`/event-details/${slug}`)}
      />
    );
  }

  return <TradeMissionRegistration />;
}

